export const LS_THEME_MODE = 'theme';
